import HospitalService from '@/common/swagger/offline/hospital-service.js';
import PlatformService from '@/common/swagger/offline/platform-service.js';
import PatientService from '@/common/swagger/offline/patient-service.js';
import FeatureService from '@/common/swagger/offline/feature-service.js';
import UdbService from '@/common/swagger/offline/udb-service.js';
import AppointmentService from '@/common/swagger/offline/appointment-service.js';
import PayService from '@/common/swagger/offline/pay-service.js';
import QuestionnairesService from '@/common/swagger/offline/questionnaires-service.js';
import PhysicalExaminationService from '@/common/swagger/offline/physical-examination-service.js';
import SearchService from '@/common/swagger/offline/search-service.js';
import SurveyService from '@/common/swagger/offline/survey-service.js';
import LectureService from '@/common/swagger/offline/lecture-service.js';
import MessageManagerService from '@/common/swagger/offline/message-manager-service';

export default {
  ...HospitalService,
  ...PlatformService,
  ...PatientService,
  ...FeatureService,
  ...UdbService,
  ...AppointmentService,
  ...PayService,
  ...QuestionnairesService,
  ...PhysicalExaminationService,
  ...SearchService,
  ...SurveyService,
  ...LectureService,
  ...MessageManagerService
};
